<chrono [value]="10" (onComplete)="timerCompleted($event)"></chrono>
